import { render, staticRenderFns } from "./VideoControl.vue?vue&type=template&id=49a810de"
import script from "./VideoControl.vue?vue&type=script&lang=js"
export * from "./VideoControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports